import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import LanguageIcon from '@mui/icons-material/Language';
import PhotoIcon from '@mui/icons-material/Photo';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';

import './style.scss';

const LinkList = (props) => {

  return (
    <List className="gas-list">
      {props.items && props.items.length > 0 && props.items.map((item, i) => 
        <ListItem 
          className="gas-list__item" key={i} button
          onClick={() => window.open(item.url, '_blank')}
        >
          <ListItemAvatar>
            <Avatar>
              {item.type === 'web' && <LanguageIcon />}
              {item.type === 'photo' && <PhotoIcon />}
              {item.type === 'video' && <VideoLibraryIcon />}
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={item.title} secondary={item.description} />
        </ListItem>
      )}
    </List>
  );
}

export default LinkList;